import React from 'react';
import { ExternalLink, FileWarning } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const EXPLORER = 'https://basescan.org/tx/';

export const fetchBreachRecords = (kypaId) =>
  fetch(`${API}/api/kypa/breach-records?kypa_id=${encodeURIComponent(kypaId)}`, { cache: 'no-store' }).then((r) => r.json());

export const fetchLatestBreachRecords = (ids) =>
  ids.length
    ? fetch(`${API}/api/kypa/breach-records/latest?kypa_ids=${encodeURIComponent(ids.join(','))}`, { cache: 'no-store' }).then((r) => r.json()).then((d) => d.agents || {})
    : Promise.resolve({});

const fmtDate = (d) => new Date(`${d}T00:00:00Z`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });

function Evidence({ r }) {
  const href = r.evidence_kind === 'tx' ? `${EXPLORER}${r.evidence}` : r.evidence;
  const text = r.evidence_kind === 'tx' ? `${r.evidence.slice(0, 8)}...${r.evidence.slice(-6)}` : 'Evidence';
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-mono text-red-300 hover:text-red-200" data-testid={`breach-record-evidence-${r.id}`}>
      {text} <ExternalLink className="w-3 h-3" />
    </a>
  );
}

export function BreachRecordList({ records, compact = false, testid = 'breach-records' }) {
  if (!records || records.length === 0) {
    return (
      <p className="text-xs text-gray-500 flex items-center gap-1.5" data-testid={`${testid}-empty`}>
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500/70" /> No breach records
      </p>
    );
  }
  return (
    <ul className="space-y-2" data-testid={testid}>
      {records.map((r) => (
        <li key={r.id} className="rounded-lg border border-red-500/20 bg-red-500/[0.04] px-3 py-2 text-xs" data-testid={`breach-record-${r.id}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="inline-flex items-center gap-1.5 font-semibold text-red-200">
              <FileWarning className="w-3.5 h-3.5" /> {r.record_type} {!compact && <span className="font-normal text-gray-300">{r.record_label}</span>}
            </span>
            <span className="text-gray-500">{fmtDate(r.occurred_on)}</span>
          </div>
          <div className="mt-1 flex items-center justify-between gap-2">
            {!compact && r.note ? <span className="text-gray-400">{r.note}</span> : <span />}
            <Evidence r={r} />
          </div>
        </li>
      ))}
    </ul>
  );
}

export const BREACH_RECORD_NOTE = 'A breach record is public evidence, not a claim, judgment, or promise of repayment.';
